module.exports = __webpack_public_path__ + "img/pt-box4-text-light.bd45a292.png";